export default {
    title: 'Le monde de Louis Granet',
    subTitle: 'Arty',
    authorName:'Louis Granet, peintre',
    authorTitle:'Propos recueillis par Aurélie Laurière',
    video:'Louis_Granet_FR.mp4',

    intro:'Entré dans la Collection Société Générale en 2017, Louis Granet est un jeune artiste actif depuis 2014. A l’occasion de son exposition dans les tours de Société Générale à La Défense, il nous parle de sa pratique de la peinture, infusée de bande dessinée.',
 
    authorQuote: '“La construction même de mes peintures est héritée de la BD. Il y a la base, le rapport entre les images et donc une dimension de narration, même si celle-ci peut être absurde et abstraite.”',

    imageCaption: 'Sans titre, 197 x 135 cm, acrylique sur toile. Toile acquise par la Collection Société Générale.',
 
  // Légendes des images

    img1:'Kiwifruit Gummy Candy, 36 x 48 cm, acrylique sur toile.',
    img2:'It’s Never Too Cold, diptyque, 182 x 245 cm, acrylique sur toile, 2018. Un voyage coloré et exotique aux États-Unis, entre nouilles et barbe à papa.',
    img4:'Louis Granet au travail dans son atelier.',
    img5:'Noble construction, Cashu Bue, 190 x 135 cm, acrylique sur toile, 2018.',

    // Témoignage

    Witness:'Stéphane Calais, artiste peintre. Ancien Professeur de Louis Granet.',
    Testimony:'“Les images de rue, de marchés, de bandes dessinées, boutiques de souvenirs se superposent, s’agglomèrent. Louis Granet a décidé d’être un témoin formel de son époque. Être peintre en 2018 est une épreuve dont il connaît les multiples difficultés et par là même en tire toute la beauté.”',


    // Interview

    Q1: 'Vous souvenez-vous de votre rencontre avec l’art ?',
    A1: 'Ma rencontre avec l’art a été, comme pour beaucoup d’enfants, une rencontre avec la bande dessinée. De mes 2-3 ans à mes 22-23 ans, je voulais d’ailleurs être auteur de bande dessinée.',

    Q2: 'C’était donc une évidence de faire des études artistiques ?',
    A2: 'Oui, j’ai étudié aux Beaux-Arts de Bordeaux, à l’école de BD d’Angoulême puis aux Arts Déco de Strasbourg. Quand j’ai quitté Bordeaux pour Angoulême, j’étais convaincu de vouloir faire de la BD. Et puis je me suis mis à peindre et je me suis rendu compte que le quotidien d’un auteur de BD ne me correspondait pas. Après mon diplôme et ma rencontre avec l’artiste Stéphane Calais, je suis arrivé à Paris en me disant : « Je veux faire artiste. »',

    Q3: 'Quel souvenir de la bande dessinée votre peinture conserve-t-elle ?',
    A3: 'La construction de mes peintures est héritée de la BD, tout comme les lignes très fluides et le fait de dessiner à partir de photos que j’ai prises. Cela dit, je ne suis pas un auteur de BD qui fait de la peinture. Je suis peintre.',

    Q4: 'En juillet 2017, l’une de vos toiles rejoignait la Collection Société Générale. Comment avez-vous accueilli la nouvelle ?',
    A4: 'C’est très agréable que des gens nous fassent confiance, nous récompensent et décident de nous présenter à un public. C’est également très important qu’ils choisissent d’acquérir des pièces ; c’est ce qui nous permet de continuer à produire.',

    Q5: 'Quels sont vos projets ?',
    A5: 'Une exposition monographique dans les tours de Société Générale à La Défense, prévue pour janvier 2019. Auparavant, une exposition collective au château du Feÿ, en octobre 2018, et, par la suite, un solo show à la Zidoun-Bossuyt Gallery, au Luxembourg.',

};

